import { isScrolledIntoView } from './scrolled-into-view';

export const animate = {
    init: () => {
        const $ = jQuery;

        const elements = $('#home-hero h1, #home-hero .ctas-wrapper, #stats-home h2, .home .tabs h2, .home .tabs .tabs-wrapper, .home .cta-full-width-image h2, .home .cta-full-width-image h3, .home .cta-full-width-image .content, .home .cta-full-width-image .ctas-wrapper, .home .cta-full-width h2, .home .cta-full-width .ctas-wrapper, #post-cards-home h2, #post-cards-home .arrow, #post-cards-home .card-item, #home-slider h2, #home-slider .tag, #home-slider #home-slider-splide, #logos-home h2, #logos-home .logos-wrapper, #testimonials-home h2, #testimonials-home .testimonials-wrapper');

        if (elements.length === 0) {
            return false;
        }

        $.each(elements, (i, element) => {
            $(window).on('scroll', () => {
                if ( ! $(element).hasClass('animation-started') && isScrolledIntoView($(element)) ) {
                    $(element).addClass('animation-started');
                }
            });
        });
    }
}